import React, { useState, useEffect, FC, useRef } from 'react';
import './stock-table-row.scss';
import { Button } from 'primereact/button';
import StockTableCountCell, { StockDestination } from '../stock-table-count-cell/stock-table-count-cell';
import { Checkbox } from 'primereact/checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { updateICProductsByShop } from '../../productSlices';
import { ContextMenu } from 'primereact/contextmenu';

export interface StockTableRowProps {
    id: string;
    name: string;
    three_liter: number;
    five_liter: number;
    seven_liter: number;
    total_quantity: number;
    total_liters: number;
    checked: boolean;
    setChecked: (checked: boolean, id: string) => void;
    setProductIdToDelete: Function;
    setWordToConfirm: Function;
    setProductToEdit: Function;
    handleStockModify: Function;
    destination: string;
}

const StockTableRow:FC<StockTableRowProps> = (stock) => {
    const dispatch: Function = useDispatch();
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const cm = useRef(null);
    const user = useSelector((state: any) => state.auth.user);
    const userAllowedToEdit = user.roleLevel >= 2;
    const [destinationShop, setDestinationShop] = useState(null);
    const items = [
        { label: 'Edit', icon: 'pi pi-user-edit', command:()=>stock.setProductToEdit({id: stock.id, name: stock.name, three_liter: stock.three_liter, five_liter: stock.five_liter, seven_liter: stock.seven_liter})},
        { label: 'Delete', icon: 'pi pi-trash', command: ()=>{stock.setProductIdToDelete(stock.id);stock.setWordToConfirm(stock.name)} }
    ];
    const handleUpdateStock = (propertyName, value, destinationShop, destination) => {
        const newStock = {...stock, [propertyName]: value, destination_shop_id: undefined, has_been_consumed: !(destination === StockDestination.Trash), destination: destination}
        if(destinationShop && destination === StockDestination.OtherShop)
            newStock.destination_shop_id = destinationShop;
        dispatch(updateICProductsByShop(selectedShop,stock.id, newStock))
    }

    return (
        <div className="stock-table-row" onContextMenu={(e) => {userAllowedToEdit ? cm.current.show(e): e.preventDefault()}}>
            <Checkbox onChange={e => stock.setChecked(e.checked, stock.id)} checked={stock.checked}></Checkbox>
            <div className="stock-table-row__label">{stock.name}</div>
            <StockTableCountCell key={stock.id + '1'} externalDestination={stock.destination} stock={stock.seven_liter} originalValue={stock.seven_liter} setStock={(c,_, destination) => handleUpdateStock('seven_liter', c, destinationShop, destination)} destinationShop={destinationShop} setDestinationShop={(c) => setDestinationShop(c)} handleStockModify={(value, destinationShop, destination) => stock.handleStockModify(stock.id, 'seven_liter', value, destinationShop, destination)} />
            <StockTableCountCell key={stock.id + '2'} externalDestination={stock.destination} stock={stock.five_liter} originalValue={stock.five_liter} setStock={(c,_, destination) => handleUpdateStock('five_liter', c, destinationShop, destination)} destinationShop={destinationShop} setDestinationShop={(c) => setDestinationShop(c)} handleStockModify={(value, destinationShop, destination) => stock.handleStockModify(stock.id, 'five_liter', value, destinationShop, destination)} />
            <StockTableCountCell key={stock.id + '3'} externalDestination={stock.destination} stock={stock.three_liter} originalValue={stock.three_liter} setStock={(c,_, destination) => handleUpdateStock('three_liter', c, destinationShop, destination)} destinationShop={destinationShop} setDestinationShop={(c) => setDestinationShop(c)} handleStockModify={(value, destinationShop, destination) => stock.handleStockModify(stock.id, 'three_liter', value, destinationShop, destination)} />
            <div className="stock-table-row__label">{stock.total_liters}</div>
            {userAllowedToEdit && <ContextMenu model={items} ref={cm} breakpoint="767px" /> }
        </div>
    );
}
         
export default StockTableRow;